module.exports = __webpack_public_path__ + "static/media/desktop-alt.9559f234.svg";